import styles from './styles.module.css';

const InputSearch = ({ term, handleKeyPress, handleButtonPress, onChange }) => (
  <div
    className={
      term
        ? 'mdn-Input mdn-Input--search mdn-Input--activatedField'
        : 'mdn-Input mdn-Input--search'
    }
  >
    <input
      className={`mdn-Input-field ${styles.InputSearch}`}
      data-mdn-type="search"
      type="search"
      id="inputSearch"
      value={term}
      onKeyPress={handleKeyPress}
      onChange={onChange}
    />
    <label htmlFor="inputSearch" className="mdn-Input-label">
      buscar...
    </label>
    <a
      href="/#"
      className={`mdn-Input-action ${styles.InputSearchButton}`}
      onClick={handleButtonPress}
    >
      <span className="mdn-Icon-busca mdn-Icon--md"></span>
    </a>
  </div>
);

export default InputSearch;
